const influencemobile = process.env.REACT_APP_ENV === 'development' ? 'influence-stage' : 'influencemobile';
const diageo = process.env.REACT_APP_ENV === 'development' ? 'survey' : 'diageo';
const cricket = process.env.REACT_APP_ENV === 'development' ? 'cricket' : 'redeem2';

export { influencemobile, diageo, cricket };
